export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-10 h-10',
  };

  return (
    <div className="flex justify-center items-center p-6">
      <div className="relative">
        <div
          className={`${sizes[size]} border-2 border-neon/20 rounded-full`}
        />
        <div
          className={`${sizes[size]} border-2 border-transparent border-t-neon rounded-full animate-spin absolute inset-0`}
        />
      </div>
    </div>
  );
}
